import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

import './ProductPage.css';

import logoImage from './../../image/logo.svg';
import iconClose from './../../image/close.svg';
import plusBtn from './../../image/plus-btn-menu.svg';
import minusBtn from './../../image/minus-btn-menu.svg';
import productPhoto from './../../image/product-photo.png';

const ProductPage = ({
    setCurrentPage,
    selectProduct,
    productCount,
    setProductCount,
    handleCloseClick,
    totalSum,
    setTotalSum,
    handlePlusClick,
    handleMinusClick,
    setIsShowProductCard,
}) => {
    const [showImage, setShowImage] = useState(true); // отображение изображения
    const [showVideo, setShowVideo] = useState(false); // отображение видео

    const hasImageOrVideo =
        selectProduct && (selectProduct.image || selectProduct.video);

    // первые 2с показывать картинку
    useEffect(() => {
        const timer = setTimeout(() => {
            if (selectProduct.video) {
                setShowImage(false);
                setShowVideo(true);
            }
        }, 1000);

        return () => clearTimeout(timer);
    }, [selectProduct.video]);

    // загрузка суммы корзины из localStorage
    useEffect(() => {
        const savedTotalSum = localStorage.getItem('totalSum');
        if (savedTotalSum) {
            setTotalSum(parseInt(savedTotalSum, 10));
        }
    }, []);

    // обновление суммы корзины в localStorage
    useEffect(() => {
        localStorage.setItem('totalSum', totalSum);
    }, [totalSum]);

    // productCount из localStorage
    useEffect(() => {
        if (selectProduct) {
            const productData = localStorage.getItem(
                `product_${selectProduct.id}`
            );
            if (productData) {
                const parsedData = JSON.parse(productData);
                setProductCount((prev) => ({
                    ...prev,
                    [selectProduct.id]: parsedData,
                }));
            } else {
                setProductCount((prev) => ({
                    ...prev,
                    [selectProduct.id]: { quantity: 0 },
                }));
            }
        }
    }, [selectProduct]);

    // количество выбранного товара
    const quantity = selectProduct
        ? productCount[selectProduct.id]?.quantity || 0
        : 0;

    // клик по корзине
    const handleCartClick = () => {
        setIsShowProductCard(false);
        setCurrentPage('CartPage');
    };

    return (
        <div className='product_page__wrapper'>
            {selectProduct && (
                <div className='product__items_wrapper'>
                    <div className='product_page__video'>
                        {showImage && (
                            <img
                                className={
                                    selectProduct.video
                                        ? 'product_page__image'
                                        : 'product_page__image_liner'
                                }
                                src={
                                    hasImageOrVideo
                                        ? `https://apihpwild.ru${selectProduct.image}`
                                        : productPhoto
                                }
                                alt={selectProduct.name}
                            />
                        )}
                        {showVideo && (
                            <ReactPlayer
                                url={`https://apihpwild.ru${selectProduct.video}`}
                                playing={true}
                                loop={true}
                                muted={true}
                                controls={false}
                                width='100%'
                                height='100%'
                                playsinline={true}
                                config={{
                                    file: {
                                        attributes: {
                                            controlsList:
                                                'nodownload nofullscreen',
                                            disablePictureInPicture: true,
                                        },
                                    },
                                }}
                            />
                        )}
                        <div className='product_page__video_add'>
                            <img
                                src={logoImage}
                                className='product_page_logo'
                            />
                            <img
                                src={iconClose}
                                className='product_page_back'
                                onClick={handleCloseClick}
                            />
                        </div>
                    </div>
                    <div className='product_page__info'>
                        <h1 className='product_page__info_title'>
                            {selectProduct.name}
                        </h1>
                        <h4 className='product_page__info_about'>
                            {selectProduct.description}
                        </h4>
                        <div className='product_page__info_price'>
                            {/* <p>
                                {selectProduct.portionWeightGrams ||
                                    selectProduct.weight}
                                г
                            </p> */}
                            <h3>{selectProduct.price}₽</h3>
                        </div>
                        <div className='product_page__info_btns'>
                            <button
                                className='product_page__info_btn'
                                onClick={() =>
                                    handleMinusClick(
                                        selectProduct.id,
                                        selectProduct.price
                                    )
                                }
                            >
                                <img src={minusBtn} />
                            </button>
                            <p>{quantity}</p>
                            <button
                                className='product_page__info_btn'
                                onClick={() =>
                                    handlePlusClick(
                                        selectProduct.id,
                                        selectProduct.name,
                                        selectProduct.price
                                    )
                                }
                            >
                                <img src={plusBtn} />
                            </button>
                        </div>
                    </div>
                    <div className='menu__main_summ'>
                        <button onClick={handleCartClick}>
                            <p className='menu__main_summ_title'>Корзина</p>
                            <h3 className='menu__main_summ_count'>
                                {totalSum}₽
                            </h3>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProductPage;
